import React from 'react';
import PropTypes from 'prop-types';
import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationListView.module.scss';

const FormDecorationListView = ({
  fieldId,
  schema,
}) => {
  if (!schema.options) return null;
  return (
    <ul className={styles.element} id={fieldId}>
      {schema.options?.map(({ id, label, value }) => (
        <li className={styles.listViewWrap} key={id}>
          <Typo variant="b02" className={styles.listItem}>
            {schema.hasTextMarkdown
              ? (
                <span
              // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: label,
                  }}
                />
              )
              : { label }}
          </Typo>
          <Typo variant="b01">{value}</Typo>
        </li>
      ))}
    </ul>
  );
};

FormDecorationListView.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({}).isRequired,
};

registerDecoration('ListView', React.memo(FormDecorationListView));

export default FormDecorationListView;
